<popup-c *ngIf="showAccountInfoPopup"
		 head="Account Information" size="large"
		 [subTitle]="'View security-related information of <b>' + mailboxEmail + '</b>'"
		 (closeCb)="onClose()">
	<div class="flxClmn f-1-0" style="overflow: auto;">

		<div class="simple-tab-row w100 flxRow">
			<ng-container *ngFor="let tab of accountInfoPopupTabs | keyvalue: gs.returnZero">
				<div class="tab-header"
					 [ngClass]="{'chosen' : activeTab === tab.value}"
					 (click)="selectAccountInfoPopupTab(tab.value)">
					<span class="hvr-opacity">{{tab.value}}</span>
				</div>
			</ng-container>
		</div>

		<div class="flxClmn gap-3 f-1-0 p-1 overflow-auto animated fadeIn" *ngIf="activeTab === accountInfoPopupTabs.userDevices && isLoaded">
			<trustifi-table-c
				class="trustifi-table" style="flex: 1 0; z-index: 5;"
				[list]="accountInfo.devices"
				[headers]="[
					{text:'Client'},
					{text:'Location'},
					{text:'IP Address'},
					{text:'Last Used', sortKey:'last_used'},
				]"
				[cellsPrototype]="[
					{html: 'clientCell'},
					{html: 'locationCell'},
					{html: 'ipCell'},
					{textKey: 'last_used', textType: 'dateAndTime'},
				]"
				[cellActions]="{
					enable: true,
					selectItemActionCb:	selectDeviceAction,
					initActionsFunction: showDeviceAction
				}"
				[options]="{
					itemsNameSingular: 'device',
					defaultSortKey: '-last_used',
				}"
			>
				<ng-template #customCells let-item let-cellId="cellId">
					<!--Action cells-->
					<span style="text-transform: capitalize;" *ngIf="cellId === 'clientCell'">
							<span *ngIf="item.agent && item.agent.browser" title="{{item.agent.raw.ua}}">
								{{item.agent.browser.name + ' (' + item.agent.browser.version + '), ' + item.agent.os.name + ' (' + item.agent.os.version + ')'}}
							</span>
							<span *ngIf="item.agent && item.agent.raw && !item.agent.browser">{{item.agent.raw.ua || 'N/A'}}</span>
						</span>
					<span style="text-transform: capitalize;" *ngIf="cellId === 'locationCell'">
							<span *ngIf="item.location && item.location[0]">{{item.location[0].country}}{{item.location[0].city ? (', ' + item.location[0].city) : ''}}</span>
							<img style="cursor: pointer; padding-left: 3px;" *ngIf="item.location[0] && item.location[0].ll" (click)="openLocation(item.location[0].ll)" title="Open in Google Maps" class="googleMaps" src="data:image/png;base64,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" alt=""/>
						</span>
					<span style="text-transform: capitalize;" *ngIf="cellId === 'ipCell'">
							<span>{{item.location[0].ip}}{{item.location[0].connection ? (' (' + item.location[0].connection + ')') : ''}}</span>
						</span>
				</ng-template>
			</trustifi-table-c>

			<!--map-->
			<div class="flxClmn w100" style="flex: 0.8 0">
				<leaflet-c class="flxClmn f-1-0 w100" [leafletCenter]="accountInfo.center_location" [markers]="accountInfo.locations"></leaflet-c>
			</div>
		</div>

		<div class="flxClmn gap-3 f-1-0 p-1 overflow-auto animated fadeIn" *ngIf="activeTab === accountInfoPopupTabs.userSignIns">
			<trustifi-table-c
				class="trustifi-table" style="flex: 1 0; z-index: 5;"
				[list]="accountInfo.userSignObj.data"
				[headers]="[
					{text:'Client'},
					{text:'Location'},
					{text:'IP Address'},
					{text:'Authentication', sortKey:'auth'},
					{text:'Last Used', sortKey:'last_used'},
				]"
				[cellsPrototype]="[
					{html: 'clientCell'},
					{html: 'locationCell'},
					{textKey: 'ipAddress', style: {'word-break': 'break-word', 'white-space': 'normal'}},
					{textKey: 'auth'},
					{textKey: 'createdDateTime', textType: 'dateAndTime'},
				]"
				[options]="{
					loadingTableFlag: accountInfo.userSignObj.inProcess,
					itemsNameSingular: 'device',
					isEllipsis: false,
					defaultSortKey: '-createdDateTime',
				}"
			>
				<ng-template #customCells let-item let-cellId="cellId">
					<!--Action cells-->
					<span style="text-transform: capitalize;" *ngIf="cellId === 'clientCell'">
						  <div *ngIf="item.deviceDetail?.displayName">{{ item.deviceDetail.displayName }}</div>
						  <div *ngIf="item.deviceDetail?.operatingSystem">{{ item.deviceDetail.operatingSystem }}</div>
						  <div *ngIf="item.deviceDetail?.browser">{{ item.deviceDetail.browser }}</div>
					</span>

					<span style="text-transform: capitalize;" *ngIf="cellId === 'locationCell'">
						<span *ngIf="item.location">{{item.location.countryOrRegion}}{{item.location.city ? (', ' + item.location.city) : ''}}</span>
						<img style="cursor: pointer; padding-left: 3px;" *ngIf="item.location?.geoCoordinates?.latitude" (click)="openLocation([item.location.geoCoordinates.latitude, item.location.geoCoordinates.longitude])" title="Open in Google Maps" class="googleMaps" src="data:image/png;base64,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" alt=""/>
					</span>

				</ng-template>
			</trustifi-table-c>
		</div>

	</div>
</popup-c>

